// extracted by mini-css-extract-plugin
module.exports = {"hover":"about_hover__kkAOE","avatar":"about_avatar__EGXrs","textAlign":"about_textAlign__GW6yz","blockAlign":"about_blockAlign__Ur_yy"};